import { useChapterIntroContent } from "@/hooks/course/useChapterIntroContent";
import ChapterIntroScroll from "@/components/course/ChapterIntroScroll";
import { CHAPTER_INTRO_FALLBACK } from "@/components/course/introFallbacks";
import { chapterIntroIllustration } from "@/lib/chapterIntroIllustration";
import { useCourseDetailStore } from "@/stores/courseDetailStore";
import type { CourseTreeNode } from "@/types/generated";

interface ChapterIntroPageProps {
  chapter: CourseTreeNode;
}

/**
 * Chapter intro route view — wires chapter data into the scroll intro layout.
 */
const ChapterIntroPage = ({ chapter }: ChapterIntroPageProps) => {
  const introProps = useChapterIntroContent(chapter, CHAPTER_INTRO_FALLBACK);
  const courseCategory = useCourseDetailStore((state) => state.courseCategory);
  const illustrationSrc = chapterIntroIllustration(courseCategory, chapter.id);

  return (
    <ChapterIntroScroll {...introProps} illustrationSrc={illustrationSrc} />
  );
};

export default ChapterIntroPage;
